import { render, staticRenderFns } from "./MonitoringFamilyBlock.vue?vue&type=template&id=4cf348b8&scoped=true&"
import script from "./MonitoringFamilyBlock.vue?vue&type=script&lang=js&"
export * from "./MonitoringFamilyBlock.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringFamilyBlock.vue?vue&type=style&index=0&id=4cf348b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf348b8",
  null
  
)

export default component.exports